import { ActionContext } from 'vuex';
import { IAppRootState } from './IAppRootState';
import { TjipVuexAction, TjipVuexMutation } from '@tjip/vuejs';
import { AppSessionStoreDataModule } from './AppSessionStoreDataModule';
import { appHypothekenService } from '@/services/appHypothekenService';
import { Hypotheek } from '@/model/Hypotheek';
import { IHypotheekResponse } from '@/model/IHypotheekResponse';
import { IHypothekenData } from './IHypothekenData';
import { appSearchService } from '@/services/appSearchService';
import { IBetaling } from '@/model/IBetaling';

export class AppHypothekenDataModule extends AppSessionStoreDataModule<IHypothekenData, IAppRootState> {
  public namespaced = true;

  constructor() {
    super('hypotheken', {
      hypotheken: [],
      currentHypotheeknummer: '',
      currentHypotheekdeelnummer: ''
    });
  }

  @TjipVuexAction
  private getHypotheken(ctx: ActionContext<IHypothekenData, IAppRootState>, force = false): Promise<Hypotheek[]> {
    if (force) {
      return Promise.all([appHypothekenService.getHypotheken(force), appSearchService.getBetalingen(force)]).then(
        ([hypotheken, betalingen]: [IHypotheekResponse[], IBetaling[]]) => {
          ctx.commit(
            'getHypothekenSucceeded',
            hypotheken.map(h => new Hypotheek(h, betalingen))
          );
          return ctx.state.hypotheken;
        }
      );
    }
    return Promise.resolve(ctx.state.hypotheken);
  }

  @TjipVuexMutation
  private getHypothekenSucceeded(state: IHypothekenData, value: Hypotheek[]) {
    state.hypotheken.splice(0, state.hypotheken.length, ...value);

    if (!state.currentHypotheeknummer || value.map(h => h.id).indexOf(state.currentHypotheeknummer) < 0) {
      state.currentHypotheeknummer = value.length === 1 ? value[0].id : '';
      state.currentHypotheekdeelnummer = '';
    }
    //    Object.assign(state, config);
  }

  @TjipVuexMutation
  private selectCurrentHypotheeknummer(state: IHypothekenData, value: string) {
    state.currentHypotheeknummer = value;
  }

  @TjipVuexMutation
  private selectCurrentHypotheekdeelnummer(state: IHypothekenData, value: string) {
    state.currentHypotheekdeelnummer = value;
  }

  @TjipVuexAction
  protected logout(ctx: ActionContext<IHypothekenData, IAppRootState>) {
    ctx.dispatch('reset');
  }
}
